import { useAuth } from '_/contexts/AuthContext';
import { useSourceContext } from '_/contexts/SourceContext';
import { formatDateTime } from '_/utils/dateUtils';
import { useMemo } from 'react';

/**
 * Hook that checks if current user is assigned to the selected source
 * (Replaces sourceUserAssignmentAccess selector)
 */
export function useSourceUserAssignment(): boolean {
  const { currentUser } = useAuth();
  const { selectedSource } = useSourceContext();

  return useMemo(() => {
    if (!currentUser?.id || !selectedSource?.assigneeId) {
      return false;
    }
    return selectedSource.assigneeId === currentUser.id;
  }, [currentUser?.id, selectedSource?.assigneeId]);
}

/**
 * Hook that formats historical source metrics for table display
 * (Replaces getHistoricalSourceMetricsTable selector)
 */
export function useHistoricalSourceMetricsTable(historicalMetrics: Record<string, any[]>) {
  return useMemo(() => {
    const formattedMetrics = Object.entries(historicalMetrics).map(([key, value]) => ({
      [key]: value.map((historicalMetric) => ({
        ...historicalMetric,
        value:
          historicalMetric?.value !== undefined && historicalMetric?.value !== null
            ? historicalMetric.value.toFixed(2)
            : '[null]',
        timestamp: historicalMetric.timestamp ? formatDateTime(historicalMetric.timestamp) : '',
      })),
    }));
    return Object.assign({}, ...formattedMetrics);
  }, [historicalMetrics]);
}
